import { createContext } from 'react';
import { SelectValue } from '../schema/interface';

/* eslint-disable */
const InputContext = createContext({
    dispatch: ({
        type,
        payload
    }: {
        type: string;
        payload?: object;
        name?: string;
        value: string | string[] | SelectValue;
    }) => {}
});

export const InputContextValues = createContext({
    formValues: {}
});
export default InputContext;
